import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomControl } from "../contexts/customControlContextFactory.js";
const CustomHTML = ()=>{
    const { params: { description } } = useCustomControl();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: !!description && /*#__PURE__*/ _jsx("span", {
            dangerouslySetInnerHTML: {
                __html: description
            }
        })
    });
};
export { CustomHTML };
